
  var _styles = {
  "ft-flight-transit-container": {
    "width": "100%"
  },
  "ft-title": {
    "position": "relative",
    "display": "flex",
    "alignItems": "center",
    "flexDirection": "row",
    "width": "100%",
    "paddingTop": 0,
    "paddingRight": 0,
    "paddingBottom": "0.33333rem",
    "paddingLeft": "0.26667rem",
    "lineHeight": "0.61333rem",
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)"
  },
  "ft-title-left": {
    "position": "relative",
    "left": "-0.2rem",
    "width": "0.08rem",
    "height": "0.4rem"
  },
  "ft-title-label": {
    "flex": 1,
    "fontSize": "0.42667rem",
    "color": "rgb(255,255,255)",
    "fontWeight": "500"
  },
  "ft-switch": {
    "textAlign": "right"
  },
  "ft-list": {
    "display": "flex",
    "flexWrap": "wrap",
    "width": "100%",
    "justifyContent": "space-between",
    "flexDirection": "row"
  },
  "ft-list-item": {
    "width": "4.64rem",
    "borderRadius": "0.34667rem",
    "marginBottom": "0.24rem",
    "overflow": "hidden",
    "display": "flex",
    "flexDirection": "column"
  },
  "ft-img": {
    "width": "100%",
    "height": "3.2rem"
  },
  "ft-content": {
    "backgroundColor": "rgb(255,255,255)",
    "display": "flex",
    "flexDirection": "column"
  },
  "ft-content-city": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "paddingTop": "0.16rem",
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem",
    "height": "1.70667rem",
    "fontSize": "0.34667rem",
    "fontWeight": "600",
    "color": "rgba(0,0,0,0.84)",
    "position": "relative",
    "top": "-0.26667rem"
  },
  "ft-transit-city": {
    "marginLeft": "0.17333rem",
    "marginRight": "0.17333rem",
    "height": "1.17333rem",
    "position": "relative",
    "top": "0.18667rem"
  },
  "ft-round-info": {
    "display": "flex",
    "alignItems": "center",
    "marginTop": "0.06667rem",
    "flexDirection": "row"
  },
  "ft-transit-icon": {
    "width": "0.29333rem",
    "height": "0.29333rem"
  },
  "ft-transit-name": {
    "width": "0.58667rem",
    "height": "0.34667rem",
    "lineHeight": "0.34667rem",
    "borderWidth": "1px",
    "borderStyle": "solid",
    "borderColor": "rgba(0,0,0,0.24)",
    "borderRadius": "0.05333rem",
    "fontSize": "0.24rem",
    "color": "rgba(0,0,0,0.24)",
    "textAlign": "center"
  },
  "ft-transit-label": {
    "textAlign": "center",
    "fontSize": "0.29333rem",
    "marginTop": "0.02667rem",
    "color": "rgba(0,0,0,0.42)",
    "fontWeight": "600"
  },
  "ft-content-date": {
    "paddingLeft": "0.32rem",
    "fontSize": "0.26667rem",
    "fontWeight": "500",
    "color": "rgba(0,0,0,0.42)",
    "marginTop": "-0.24rem"
  },
  "ft-content-price": {
    "color": "rgb(255,102,0)",
    "fontSize": "0.4rem",
    "fontWeight": "600",
    "marginTop": "0.10667rem",
    "marginBottom": "0.32rem",
    "marginLeft": "0.32rem",
    "display": "flex",
    "alignItems": "center",
    "flexDirection": "row"
  },
  "ft-price-symbol": {
    "fontSize": "0.29333rem",
    "fontWeight": "700"
  },
  "ft-price-large": {
    "fontSize": "0.4rem",
    "fontWeight": "600"
  },
  "ft-bottom-btn": {
    "width": "100%",
    "lineHeight": "0.88rem",
    "height": "0.88rem",
    "backgroundColor": "rgb(255,102,0)",
    "color": "rgb(255,255,255)",
    "textAlign": "center",
    "fontSize": "0.34667rem",
    "fontWeight": "500"
  }
};



  module.exports = _styles;
  